// extracted by mini-css-extract-plugin
export var linkhover = "droidal-module--linkhover--lnEIg";
export var bottom = "droidal-module--bottom--zAnH9";
export var right = "droidal-module--right--WnrBP";
export var patientcontent = "droidal-module--patientcontent--4qOeL";
export var downloadlinks = "droidal-module--downloadlinks--I25tI";
export var downloadbtn = "droidal-module--downloadbtn--N6LYo";
export var left = "droidal-module--left--cnFeG";
export var callout = "droidal-module--callout--XCn5Z";
export var link = "droidal-module--link--ug4-V";
export var top = "droidal-module--top--GPZYp";
export var logolink = "droidal-module--logolink--XH4lF";
export var center = "droidal-module--center--2lA1c";
export var lefttop = "droidal-module--lefttop--qaMUD";
export var leftbottom = "droidal-module--leftbottom--oDahu";
export var patientheading = "droidal-module--patientheading--7puc5";
export var request = "droidal-module--request--8OjeN";
export var bg = "droidal-module--bg--OL2oP";
export var bgxl = "droidal-module--bgxl--IjKbY";
export var bgdesktop = "droidal-module--bgdesktop--8wMK6";
export var bgtablet = "droidal-module--bgtablet--+htaF";
export var bgmobile = "droidal-module--bgmobile--eKwfq";
export var logo = "droidal-module--logo--Szpy5";
export var patientname = "droidal-module--patientname--No8gA";
export var heading = "droidal-module--heading--3mMOg";
export var blurb = "droidal-module--blurb--SSN27";
export var icon = "droidal-module--icon--sBva2";
export var insurance = "droidal-module--insurance--kORaQ";
export var insurancebottom = "droidal-module--insurancebottom--usFDN";
export var insuranceimage = "droidal-module--insuranceimage--3sd1C";
export var sronly = "droidal-module--sronly--0x7X2";
export var contentleft = "droidal-module--contentleft--bQgAz";
export var linkcard = "droidal-module--linkcard--KgrcT";
export var linktitle = "droidal-module--linktitle--Tu8l7";
export var iframeResponsiveContainerBooking = "droidal-module--iframeResponsiveContainerBooking--l-2WN";